import Icon from "@ant-design/icons";

const Map2Svg = () => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 25 25"
		fill="none"
		xmlns="http://www.w3.org/2000/svg">
		<path
			d="M14.44 8.06006L1 21.5001"
			stroke="black"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M15 3H2.5C2.10218 3 1.72064 3.15804 1.43934 3.43934C1.15804 3.72064 1 4.10218 1 4.5V22.5C1 22.8978 1.15804 23.2794 1.43934 23.5607C1.72064 23.842 2.10218 24 2.5 24H20.5C20.8978 24 21.2794 23.842 21.5607 23.5607C21.842 23.2794 22 22.8978 22 22.5V10"
			stroke="black"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M7.5 6C7.04946 5.6621 6.49803 5.48621 5.93505 5.50084C5.37206 5.51548 4.83051 5.71977 4.39813 6.08062C3.96576 6.44147 3.66788 6.93774 3.55278 7.48903C3.43767 8.04032 3.51208 8.61432 3.76394 9.11803C4.01579 9.62175 4.43035 10.0257 4.94044 10.2644C5.45054 10.503 6.02628 10.5625 6.57439 10.4331C7.12249 10.3037 7.61086 9.99307 7.96035 9.55146C8.30985 9.10985 8.5 8.56317 8.5 8H6.5"
			stroke="black"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M22 18.2901V13.9201C20.2892 13.4323 18.4856 13.3668 16.7439 13.729C15.0023 14.0913 13.3744 14.8706 12 16.0001V24.0001"
			stroke="black"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M19 11C21.7614 11 24 8.76142 24 6C24 3.23858 21.7614 1 19 1C16.2386 1 14 3.23858 14 6C14 8.76142 16.2386 11 19 11Z"
			stroke="black"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M15.1797 14.1799L18.9997 17.9999L21.9997 14.9999"
			stroke="black"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M3.5 24L16.96 10.54"
			stroke="black"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);
export const Map2Icon = props => <Icon component={Map2Svg} {...props} />;
